import React from "react";
import { ChoiceTypes, PageQuestionOption } from "../../types/hexpertTypes";
import { HexCheckbox } from "../Checkbox/HexCheckbox";
import { HexRadioItem } from "../RadioItem/HexRadioItem";
import { LargeSelectButton } from "./LargeSelectButton";
import { SelectButton } from "./SelectButton/SelectButton";

type TButtonMapper = {
  type: ChoiceTypes;
  props: PageQuestionOption;
  name: string;
  action?: () => void;
  selected?: boolean;
};

export const ButtonMapper = ({
  type,
  name,
  action,
  selected,
  props,
}: TButtonMapper) => {
  switch (type) {
    case ChoiceTypes.BUTTON:
      return (
        <SelectButton
          {...props}
          label={props.Caption}
          name={name}
          key={props.Value}
          selected={selected}
          action={action}
        />
      );
    case ChoiceTypes.LARGE_BUTTON:
      return (
        <LargeSelectButton
          {...props}
          label={props.Caption}
          name={name}
          key={props.Value}
          selected={selected}
          onChange={action}
        />
      );
    case ChoiceTypes.CHECKBOX:
      return (
        <HexCheckbox
          {...props}
          label={props.Caption}
          name={name}
          key={props.Value}
          onChange={action}
          selected={selected}
        />
      );
    case ChoiceTypes.RADIO:
      return (
        <HexRadioItem
          {...props}
          label={props.Caption}
          name={name}
          key={props.Value}
          onChange={action}
          selected={selected}
        />
      );
    default:
      return (
        <SelectButton
          {...props}
          label={props.Caption}
          name={name}
          key={props.Value}
          selected={selected}
          action={action}
        />
      );
  }
};
